import React from 'react';

interface Props {
  children: React.ReactNode;
}

export default function PageHeaderSubheader({ children }: Props) {
  return <>{children}</>;
}
